import React from 'react';
import { useSelector } from 'react-redux';
import { getRregionalnoeOtdelenieFromRoles } from '../../../common/Tool';
import YacheikiUslugiBlock from '../../components/YacheikiUslugiBlock'
import PageLayout from '../../components/PageLayout';
import { GET, errorCatch, useAuth } from 'fennec-ui';
import { useLocaladminContext } from '../../../common/Context';

export default function LocaladminComissionServices(props) {
    const local = useLocaladminContext();
    // const regionalnoeOtdelenie = useSelector(getRregionalnoeOtdelenieFromRoles(["АдминистраторОтделения", "АдминистраторМероприятийРО"], true));
    const auth = useAuth()
    // const [regionalnoeOtdelenie, setRegionalnoeOtdelenie] = React.useState([])
    // React.useEffect(()=>{
    //     GET(auth, '/api/ro/list-by-admin', ({data})=>{
    //         setRegionalnoeOtdelenie(data);
    //     }, errorCatch)
    // }, [])

    return (<PageLayout>
        <YacheikiUslugiBlock {...props} source={"/api/yacheikiuslugi/list/reg"}
        queryDetail="model"
            sourceKey="reg"
            create={true}

            ctx={{organizatorRegionalnoeOtdelenieID: local?.ID}}

            // context={{
            //     collection: regionalnoeOtdelenie,
            //     name: (item) => item.nazvanie,
            //     mix: (item) => {
            //         return {
            //             // organizatorFederatsiyaID: 1, // Организатор федерация
            //             // organizatorShkolaID: ID, // Организатор школа
            //             // organizatorMeropriyatiyaID: ID, // Организатор мероприятия
            //             organizatorRegionalnoeOtdelenieID: item.ID // Организатор региональное отделение
            //         }
            //     }
            // }}
        />
    </PageLayout>);
}
